import { useMemo } from "react";

import { typedQueryClient } from "hooks";
import { LeadsQueryKeys } from "modules/LeadsDashboard/queryKeys";

import type { WebSocketMessageListener } from "components";
import type { Snooze } from "models";

export const useSnoozedLeadsListeners = () => {
  const listeners = useMemo(() => {
    const snoozeListeners: WebSocketMessageListener<Snooze>[] = [
      {
        model: "Snooze",
        action: "upsert",
        callback: ({ data: snooze }) => {
          const snoozedLeads = typedQueryClient.getQueryData(LeadsQueryKeys.listSnoozed);
          if (!snoozedLeads) return;

          const snoozeItems = snoozedLeads.items ?? [];
          const snoozeIdx = snoozeItems.findIndex(s => s.id === snooze.id);
          const isNewSnooze = snoozeIdx < 0;

          typedQueryClient.setQueryData(LeadsQueryKeys.listSnoozed, {
            ...snoozedLeads,
            items: isNewSnooze ? [...snoozeItems, snooze] : snoozeItems.with(snoozeIdx, { ...snoozeItems[snoozeIdx], ...snooze }),
            nb_items: isNewSnooze ? snoozedLeads.nb_items + 1 : snoozedLeads.nb_items
          });
        }
      }
    ];

    return [...snoozeListeners];
  }, []);

  return listeners;
};
